import { defineMessages } from 'react-intl';

export default defineMessages({
  headlineDefault: {
    id: 'WELCOME_REGISTRATION_VIA_CV_HEADLINE_DEFAULT',
    defaultMessage: 'Schneller vorankommen (optional)',
  },
  headlineSuccess: {
    id: 'WELCOME_REGISTRATION_VIA_CV_HEADLINE_SUCCESS',
    defaultMessage: 'Dein Lebenslauf',
  },
  descriptionDefault: {
    id: 'WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_DEFAULT',
    defaultMessage:
      'Lade jetzt Deinen Lebenslauf hoch und wir befüllen Dein XING Profil automatisch mit Deinen Daten.',
  },
  descriptionSuccess: {
    id: 'WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_SUCCESS',
    defaultMessage:
      'Wir haben deinen Lebenslauf automatisch mit Deinen Daten befüllt.{br}{br} Bitte schau kurz, ob alles stimmt und trag die Infos ein, die noch fehlen.',
  },
  buttonLabel: {
    id: 'WELCOME_REGISTRATION_VIA_CV_BUTTON_LABEL',
    defaultMessage: 'Lebenslauf hochladen',
  },
  fileInfoLabel: {
    id: 'WELCOME_REGISTRATION_VIA_CV_FILE_INFO_LABEL',
    defaultMessage: 'PDF, DOCX, Pages (max. 100 MB)',
  },
  commonErrorLabel: {
    id: 'WELCOME_REGISTRATION_VIA_CV_COMMON_ERROR_LABEL',
    defaultMessage: 'Das hat leider nicht geklappt. Versuch’s bitte noch mal.',
  },
  badFileErrorLabel: {
    id: 'WELCOME_REGISTRATION_VIA_CV_BAD_FILE_ERROR_LABEL',
    defaultMessage:
      'Wir konnten die Datei {fileName} nicht laden. Das kann daran liegen, dass sie zu groß ist oder das falsche Format hat.',
  },
});
